// Textos del listado de la promo por viajes (trip-promos). Se registran junto al
// resto de vocabularios en AppComponent; setTranslation los fusiona.
export const locale = {
  lang: 'en',
  data: {
    TRIP_PROMOS: {
      BREADCRUMB_ARIA: 'Breadcrumb',
      BREADCRUMB_MARKETING: 'Marketing',
      BREADCRUMB_PROMO: 'Trip promo',
      TITLE: 'Trip promo',
      DESCRIPTION:
        "Users who have had the trip promo activated. After completing the required verified trips of more than 10 km (full price or cost 0, as driver, as passenger or both), the amount is automatically paid into their wallet. It has no fraud consequences.",
      SEARCH_PLACEHOLDER: 'Search name, email or phone…',
      SEARCH_ARIA: 'Search user',
      STATUS_ARIA: 'Status',
      STATUS_ALL: 'Status: all',
      STATUS_ACTIVE: 'In progress',
      STATUS_COMPLETED: 'Completed',
      STATUS_CANCELLED: 'Cancelled',
      FILTER_COMPLETED: 'Completed',
      FILTER_CANCELLED: 'Cancelled',
      CLEAR_FILTERS: 'Clear filters',
      ACTIVATE: 'Activate promo',
      LOADING: 'Loading promotions…',
      RETRY: 'Retry',
      EMPTY_FILTERED: 'No promotion matches the search.',
      EMPTY:
        'No promotion has been activated yet. Activate one with “Activate promo” or from the user profile.',
      TH_USER: 'User',
      TH_AMOUNT: 'Amount',
      TH_ACTIVATED_BY: 'Activated by',
      TH_DATE: 'Date',
      TH_PROGRESS: 'Progress',
      TYPE_ARIA: 'Trip type',
      TYPE_ALL: 'Type: all',
      TYPE_PVP: 'Full price',
      TYPE_WITHOUT_COST: 'Cost 0',
      TYPE_ANY: 'Any',
      ROLE_ANY: 'Driver or passenger',
      ROLE_DRIVER: 'Driver only',
      ROLE_RIDER: 'Passenger only',
      TH_TYPE: 'Type',
      TH_STATUS: 'Status',
      OPEN: 'Open',
      PROGRESS_TITLE: '{{done}} of {{required}} trips',
      DEPOSITED_ON: 'Paid in on {{date}}',
      CANCELLED_BY: 'Cancelled by {{name}} on {{date}}',
      VIEW_PROFILE: 'View profile',
      SHOWING: 'Showing',
      OF: 'of',
      PROMOS: 'promotions',
      PER_PAGE_LABEL: 'Promotions per page',
      PER_PAGE_OPTION: '{{n}} per page',
      PREV_PAGE: 'Previous page',
      NEXT_PAGE: 'Next page',
      PREV: 'Previous',
      NEXT: 'Next',
      ERROR_FORBIDDEN: 'You do not have permission to view this list.',
      ERROR_LOAD: 'The list could not be loaded.',
    },
  },
};
